const sendEmail = (data) => {
  const requestOptions = {
    method: "POST",
    headers: {"Content-Type": "application/json"},
    body: JSON.stringify({
      service_id: "service_f6upc63",
      template_id: "template_a1zfsnz",
      user_id: "user_i97d5wPMp43F0fk8w1qEU",
      template_params: {
        from_name: "AZOMO designer",
        message: data.message,
        collection_url: data.href + "/" + data.collection_url,
        email_to: data.email_to,
      },
    }),
  };

  return new Promise((res, rej) => {
    fetch(
      "https://api.emailjs.com/api/v1.0/email/send",
      requestOptions
    ).then((response) => res(response));
  });
};

const deleteFromDb = (id) => {
  var db;
  const dbName = "azomo2021";

  var request = indexedDB.open(dbName, 5);

  request.onupgradeneeded = function (event) {
    var db = event.target.result;

    var objectStore = db.createObjectStore("azomoStore", {
      autoIncrement: true,
    });

    objectStore.transaction.oncomplete = function (event) {
      db.transaction("azomoStore", "readwrite").objectStore("azomoStore");
    };
  };

  request.onsuccess = function (e) {
    db = e.target.result;

    var transaction = db.transaction(["azomoStore"]);
    var objectStore = transaction.objectStore("azomoStore");

    var request2 = objectStore.getAll();
    request2.onsuccess = function (e) {};

    var request1 = db
      .transaction(["azomoStore"], "readwrite")
      .objectStore("azomoStore")
      .delete(id);

    return new Promise((res, rej) => {
      request1.onsuccess = function (event) {
        res("deleted");
      };
    });
  };
};

const loadFromDb = () => {
  var db;
  const dbName = "azomo2021";

  var request = indexedDB.open(dbName, 5);

  let lista = [];

  request.onupgradeneeded = function (event) {
    var db = event.target.result;

    var objectStore = db.createObjectStore("azomoStore", {
      autoIncrement: true,
    });

    objectStore.transaction.oncomplete = function (event) {
      db.transaction("azomoStore", "readwrite").objectStore("azomoStore");
    };
  };
  return new Promise((res, rej) => {
    request.onsuccess = function (e) {
      db = e.target.result;

      if (db.objectStoreNames.length === 0) {
        return lista;
      }

      var transaction = db.transaction(["azomoStore"]);
      var objectStore = transaction.objectStore("azomoStore");

      var req = objectStore.openCursor();

      req.onerror = function (event) {
        //error
      };

      req.onsuccess = function (event) {
        let cursor = event.target.result;
        if (cursor) {
          let key = cursor.primaryKey;
          let value = cursor.value;
          lista.push({id: key, ...value});
          cursor.continue();
        } else {
          res(lista);
        }
      };
    };
  });
};

const addToDb = (
  lightContrast,
  darkContrast,
  stitching,
  patchColor,
  azomo,
  quantity,
  price,
  extraOptions,
  totalPrice,
  name,
  garmentName,
  type,
  hasPatch,
  hasContrast
) => {
  var db;
  const dbName = "azomo2021";

  var request = indexedDB.open(dbName, 5);

  request.onupgradeneeded = function (event) {
    var db = event.target.result;

    var objectStore = db.createObjectStore("azomoStore", {
      autoIncrement: true,
    });

    objectStore.transaction.oncomplete = function (event) {
      db.transaction("azomoStore", "readwrite").objectStore("azomoStore");
    };
  };

  request.onsuccess = function (e) {
    db = e.target.result;

    var transaction = db.transaction(["azomoStore"], "readwrite");
    var objectStore = transaction.objectStore("azomoStore");
    var request1 = objectStore.add({
      name,
      garmentName,
      lightContrast,
      darkContrast,
      stitching,
      patchColor,
      azomo,
      quantity,
      price,
      extraOptions,
      totalPrice,
      type,
      hasPatch,
      hasContrast,
    });
    request1.onerror = function (event) {
      // error
    };
    request1.onsuccess = function (event) {
      // success
    };
  };
};

export {addToDb, sendEmail, loadFromDb, deleteFromDb};
